import { Link } from 'react-router-dom';
import { categories } from '@/mocks/forum';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500">
                <i className="ri-heart-pulse-line text-lg text-background-50"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                爱情岛论坛
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              让每一份情感都被温柔以待。爱情岛论坛致力于为每一位用户提供温暖、真诚、开放的情感交流空间。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-100"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-100"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-background-100"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/category/love-skills" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">恋爱技巧</Link></li>
              <li><Link to="/category/love-stories" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">情感故事</Link></li>
              <li><Link to="/category/qa" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">情感问答</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line"></i> hello@aiqingdao.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line"></i> 0571-88889999
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line"></i> 杭州市西湖区文三路478号
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2018-2026 爱情岛论坛 版权所有 | 浙ICP备xxxxxxxx号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">社区规范</a>
          </div>
        </div>
      </div>
    </footer>
  );
}